import React, { Component } from 'react';
import { MainContent, Content } from 'client/components/App';
import BeRemoteErrorAlert from 'client/components/Be/BeRemoteErrorAlert';
import { push } from 'connected-react-router';
import { Helmet } from 'react-helmet';
import _ from 'lodash';
import { connect } from 'react-redux';
import * as indexActions from 'client/redux/endpoint/indexActions';
import * as urlHelpers from 'client/helpers/urlHelpers';
import { getStateSearch } from 'client/redux/apiHelpers';
import { onEndpointDelete } from 'client/redux/endpoint/eventHandlerActions';
import EndpointTable from 'client/components/Endpoint/components/EndpointTable';

class EndpointIndex extends Component {

  constructor (props) {
    super(props);
    this.getDataDebounced = _.debounce(this.getData, 200);
  }

  componentDidMount () {
    this.getData();
    // const filter = {...this.props.filter, ...this.props.search};
    // return this.handleFilter(filter);
  }

  componentDidUpdate (prevProps) {
    const currQuery = this.getQuery(this.props);
    const prevQuery = this.getQuery(prevProps);
    if (!_.isEqual(currQuery, prevQuery)) {
      this.getData();
    }
  }

  handleDeleteEndpoint = id => {
    return this.props.endpointIndexDelete(id).then(this.props.onEndpointDelete).then(this.getData);
  };

  getQuery = props => urlHelpers.parseQuerystring(_.get(props, 'location.search'));

  getData = (overrideWith = {}) => {
    const query = this.getQuery(this.props);
    return this.props.endpointIndex(query);
  };

  handleOrderBy = (orderBy, orderDirection) => {
    const url = this.getUrlWithModifiedQuery({orderBy, orderDirection});
    return this.props.push(url);
  };

  handleSetPage = page => {
    if (this.props.page === page) return;
    const url = this.getUrlWithModifiedQuery({page});
    return this.props.push(url);
  };

  handleFilter = (filter = {}) => {
    const url = this.getUrlWithModifiedQuery(filter);
    return this.props.push(url);
  };

  handleSetColumns = columns => {
    return this.props.instanceIndexSetColumns(columns);
  };

  getUrlWithModifiedQuery = (query = {}) => {
    const { location } = this.props;
    const newQuery = {
      ...this.getQuery(this.props),
      ...query,
    };
    return urlHelpers.formatLocationWithQuery(location, newQuery);
  };

  renderError (error) {
    return (
      <Content>
        <Helmet>
          <title>Endpoints Overview</title>
        </Helmet>
        <MainContent>
          <BeRemoteErrorAlert error={error} />
        </MainContent>
      </Content>
    );
  }

  render () {
    const {
      isReading,
      endpoints,
      pages,
      limit,
      offset,
      count,
      error,
    } = this.props;
    const query = this.getQuery(this.props);
    if (error) return this.renderError(error);
    return (
      <Content>
        <MainContent>
          <Helmet>
            <title>Endpoints Overview</title>
          </Helmet>
          <EndpointTable
            className="panel-default panel-border"
            loading={isReading}
            onOrderBy={this.handleOrderBy}
            onSetPage={this.handleSetPage}
            orderBy={query.orderBy}
            orderDirection={query.orderDirection}
            onDeleteEndpoint={this.handleDeleteEndpoint}
            onFilter={this.handleFilter}
            onRefresh={this.getData}
            filter={query}
            endpoints={endpoints}
            count={count}
            limit={limit}
            offset={offset}
            page={parseInt(query.page, 10) || 1}
            pages={pages}
          />
        </MainContent>
      </Content>
    );
  }

}

const actions = {
  ...indexActions,
  onEndpointDelete,
  push,
};

const mapStateToProps = state => ({
  ...state.endpoint.index,
  search: getStateSearch(state),
});

export default connect(mapStateToProps, actions)(EndpointIndex);
